import { Component, input, Input } from '@angular/core';
import {
    FilledLinkToWebField,
    KeyTextField,
    LinkField,
    NumberField,
    RichTextField,
    SelectField,
    Slice,
    TitleField
} from '@prismicio/client';
import { Member } from '../team-slice/team-slice.component';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';
import { LinkComponent } from '../../link/link.component';

@Component({
    selector: 'app-text-and-building-blocks-slice',
    standalone: true,
    imports: [RenderHtmlPipe, LinkComponent],
    templateUrl: './text-and-building-blocks-slice.component.html',
    styleUrl: './text-and-building-blocks-slice.component.scss'
})
export class TextAndBuildingBlocksSliceComponent {
    body = input<TextAndBuildingBlocksSlice>();
}

export type TextAndBuildingBlocksSlice = Slice<
    'text_and_buildingblocks',
    {
        title: RichTextField;
        description: RichTextField;
        button_link: LinkField;
        button_action: SelectField;
        button_title: KeyTextField;
    },
    {
        building_block: KeyTextField;
    }
>;
